import { useMemo } from 'react'

import { BRAND_LOCATION_GROUP_ID } from 'pared/constants/brands'
import useBrands from 'pared/layouts/hooks/useBrands'

import { IApiDataType } from '../types'
import useCorporateWithoutBreakdownFilter from './useCorporateWithoutBreakdownFilter'
import { useLocationFilterQuery } from './useLocationFilter'

const useCorporateWithoutBreakdownAndLocationFilter = () => {
  const corporateWithoutBreakdownFilter = useCorporateWithoutBreakdownFilter()
  const { brand } = useBrands()
  const locationFilter = useLocationFilterQuery(
    BRAND_LOCATION_GROUP_ID[brand],
    false,
  )

  return {
    data: useMemo((): IApiDataType => {
      if (!corporateWithoutBreakdownFilter.data || !locationFilter.data)
        return null

      const allStores = corporateWithoutBreakdownFilter.data?.values.find(
        (v) => v.id === 'all-stores',
      )

      return {
        defaultValue: ['all-stores-root', 'all-stores'],
        values: [
          {
            id: 'all-stores-root',
            parentId: 'root',
            label: 'All Stores',
          },
          ...(!allStores
            ? []
            : [
                {
                  ...allStores,
                  parentId: 'all-stores-root',
                  label: 'All',
                },
              ]),
          ...corporateWithoutBreakdownFilter.data.values.filter(
            (v) => v !== allStores,
          ),
          ...locationFilter.data.values.map((v) => ({
            ...v,
            parentId: 'all-stores-root',
          })),
        ],
      }
    }, [corporateWithoutBreakdownFilter.data, locationFilter.data]),
    loading: corporateWithoutBreakdownFilter.loading || locationFilter.loading,
  }
}

export default useCorporateWithoutBreakdownAndLocationFilter
